import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './scss/App.scss';

import NotFound from './components/pages/NotFound';
import Login from './components/pages/auth/Login';
import AlertApp from './components/pages/alerts/AlertApp';

import RegisterUser from './components/pages/auth/RegisterUser';
import ForgotPassword from './components/pages/auth/ForgotPassword';
import Splash from './components/Splash';
import LazyLoader from './components/LazyLoader';
import { verifyTokenAsync } from './redux/asyncActions/authAsyncActions';

const App = () => {
  const authObj = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  // const { authLoading, isAuthenticated } = authObj;

  // useEffect(() => {
  //   dispatch(verifyTokenAsync());
  // }, [dispatch]);

  // if (authLoading) {
  //   return <Splash showLogin={false} />;
  // }

  return (
    <div className='App'>
      <BrowserRouter>
        <Routes>
          <Route
            path='/'
            title='HealthCarePlatform: Login'
            element={<Login />}
          />
          <Route
            path='/dashboard/*'
            title='HealthCarePlatform: Login'
            element={<AlertApp />}
          />

          <Route
            path='/registration'
            title='HealthCarePlatform: Registration'
            element={<RegisterUser />}
          />
          <Route
            path='/forgot'
            title='HealthCarePlatform: Registration'
            element={<ForgotPassword />}
          />

          {/* <Route path="/reset" title="HealthCarePlatform: Registration" element={ResetPassword} /> */}

          <Route
            path='*'
            title='HealthCarePlatform: 404 NOT FOUND'
            element={<NotFound />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;